var Spotlight = {
    ui: {
        event: {
            playlistSelect: function () {
                var selector = {
                    thumbnail: '.c-alumni__thumbnail',
                    detailsContainer: '.c-alumni__details-container',
                    active: '.active',
                    overview: '.c-alumni__bio-overview',
                    cssClass: {
                        activeThumbnail: 'c-active-thumbnail',
                        active: 'active',
                        quotation: 'quotation',
                    },
                    element: {
                        image: 'img',
                    },
                    data: {
                        bio: 'bio'
                    },
                };

                function init() {
                    selectBioInPlaylist();
                    setFirstItemAsActive();
                }

                function selectBioInPlaylist() {
                    jQuery(selector.thumbnail).click(function () {

                        //Remove active class to all images in playlist
                        jQuery(selector.thumbnail).find(selector.element.image).removeClass(selector.cssClass.activeThumbnail);

                        //Adds active class to selected image in playlist
                        jQuery(this).find(selector.element.image).addClass(selector.cssClass.activeThumbnail);

                        var thumbnail = jQuery(this).find(selector.element.image).data(selector.data.bio);
                        jQuery(selector.detailsContainer).removeClass(selector.cssClass.active);

                        jQuery(selector.detailsContainer).each(function () {
                            var currentData = jQuery(this).data(selector.data.bio);

                            //Maps/Match the thumbnail data attribute to the bio description
                            if (thumbnail == currentData) {
                                jQuery(this).addClass(selector.cssClass.active).fadeIn("slow");
                                jQuery(selector.detailsContainer).not(selector.active).hide();
                                var overview = jQuery(this).find(selector.overview);

                                //Checks is bio overview has text
                                if (overview.text().length == 0) {
                                    //Remove quotation class
                                    overview.parent().removeClass(selector.cssClass.quotation);
                                }

                                if (isMobile()) {
                                    //Remove quotation class in mobile
                                    overview.parent().removeClass(selector.cssClass.quotation);
                                }
                            }
                        });
                    });
                }

                function setFirstItemAsActive() {
                    jQuery(selector.thumbnail)[0].click();
                }

                function isMobile() {
                    if (jQuery(window).width() <= 640) {
                        return true;
                    }
                }

                return {
                    init: init
                };
            },

            dataAttrManipulation: function () {
                var selector = {
                    playlist: '.c-alumni__container .ml-playlists .ml-playlist.spotlight',
                    thumbnail: '.c-alumni__thumbnail img'
                };

                function init() {
                    imageAttrManipulation();
                    attrManipulationOnResize();
                }

                function isMobile() {
                    if (jQuery(window).width() <= 640) {
                        return true;
                    }
                }

                function imageAttrManipulation() {
                    jQuery(selector.thumbnail).each(function () {
                        var mobileSrc = jQuery(this).data('mobile-src');
                        var desktopSrc = jQuery(this).data('desktop-src')

                        if (isMobile()) {
                            jQuery(this).attr('src', mobileSrc);
                        } else {
                            jQuery(this).attr('src', desktopSrc);

                        }
                    });
                }

                function attrManipulationOnResize() {
                    jQuery(window).on('resize', function () {
                        imageAttrManipulation();
                    });
                }

                return {
                    init: init

                }
            },

            mobileUIManipulation: function () {
                var selector = {
                    quotation: '.quotation',
                    excerpt: '.c-alumni__excerpt > div',
                    overview: '.c-alumni__bio-overview',
                    title: '.c-alumni__title',
                    collapseBox: '.collapse-box',
                    cssClass: {
                        quotation: 'quotation',
                        alumniCollapseBox: 'c-alumni__collapse-box',
                    },
                };

                function init() {
                    removeQuotationsInMobile();
                    removeQuotationsOnResize();
                    addClassInCollapseBox();
                }

                function isMobile() {
                    if (jQuery(window).width() <= 640) {
                        return true;
                    }
                }

                function removeQuotationsInMobile() {

                    if (isMobile()) {
                        hideQuotations();
                    } else {
                        showQuotations();
                    }
                }

                function hideQuotations() {
                    jQuery(selector.excerpt).removeClass(selector.cssClass.quotation);

                }

                function showQuotations() {
                    jQuery(selector.excerpt).addClass(selector.cssClass.quotation);
                }

                function removeQuotationsOnResize() {
                    jQuery(window).on('resize', function () {
                        removeQuotationsInMobile();
                    });
                }

                function addClassInCollapseBox() {
                    jQuery(selector.title).closest(selector.collapseBox).addClass(selector.cssClass.alumniCollapseBox);

                }

                return {
                    init: init,
                }
            },
        },
    },
};

jQuery(document).ready(function () {
    Spotlight.ui.event.playlistSelect().init();
    Spotlight.ui.event.dataAttrManipulation().init();
    Spotlight.ui.event.mobileUIManipulation().init();
});